import { useCreatorTeamAccess } from '../../hooks/use-creator-team-access'
import { EditCreatorAccessForm } from './form'
import { AccessEditPageSkeleton } from './skeleton'

export const CreatorAccessEdit = ({ id }: { id: number }) => {
  const { creatorAccess, availablePermissions, membersMap, isFetching } =
    useCreatorTeamAccess(id)

  if (isFetching) {
    return <AccessEditPageSkeleton />
  }

  if (!creatorAccess || !availablePermissions || !membersMap) {
    return <span>No data found.</span>
  }

  return (
    <EditCreatorAccessForm
      creatorAccess={creatorAccess}
      availablePermissions={availablePermissions}
      membersMap={membersMap}
      creatorId={id}
    />
  )
}
